import { PropsWithChildren } from 'react';

type FormSectionProps = {
  title: string;
};

export const FormSection = ({ title, children }: PropsWithChildren<FormSectionProps>) => (
  <div className="flex flex-col gap-3 pt-1 pb-3 pr-4">
    <p className="text-hm font-semibold font-secondary">{title}</p>
    <div className="flex flex-col gap-4">{children}</div>
  </div>
);
